const Divider = () => (
  <div className="absolute bottom-2 top-3 start-1 end-[3px] bg-[var(--ds-inner-tab-divider-color)]" />
);

export default Divider;
